<script setup lang="ts">
/**
 * SearchLauncher — 워크스페이스 GNB 우측 검색 아이콘 알약(078 ui-contract §1).
 *
 * 노출 폭: 기본(<980)·≥1440 노출, 980~1439 는 숨긴다 — 메뉴 알약이 빠듯해 로그인 상태(마이페이지+로그아웃)
 * 1280 에서 메뉴 글자가 1~3px 넘친다(실측). ⌘K·히어로 검색창은 그 구간에도 그대로 동작(SC-005 GNB 배치 불변).
 * 헤더 폭이 1440 상한(`max-w-page-workspace`)이라 더 넓은 화면에서도 텍스트 알약으로 늘리지 않는다.
 * 클릭은 패널만 연다 — 열린 메가메뉴·모바일 메뉴 정리는 셸이 `store.isOpen` 감시로 한 곳에서 처리한다.
 */
import { Search } from 'lucide-vue-next';

import { SEARCH_COPY } from '#/data/analysis/uiCopy';
import { useUnifiedSearchStore } from '#/stores/unifiedSearch';

defineOptions({ name: 'SearchLauncher' });

const store = useUnifiedSearchStore();
</script>

<template>
  <button
    type="button"
    class="flex h-12 w-12 flex-none items-center justify-center rounded-full bg-white text-ws-green shadow-sm transition-colors hover:text-ws-green-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-ws-green lg:hidden min-[1440px]:flex"
    :aria-label="SEARCH_COPY.launcherAria"
    aria-keyshortcuts="Meta+K Control+K"
    @click.stop="store.open('gnb')"
  >
    <Search :size="20" :stroke-width="2.2" />
  </button>
</template>
